import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-line-with-buttons',
  templateUrl: './line-with-buttons.component.html',
  styleUrls: ['./line-with-buttons.component.scss'],
})
export class LineWithButtonsComponent {
  @Input() title: string = '';
  @Input() data: Array<{ severity: string; icon: string }> = [];
  @Output() buttonClick = new EventEmitter();
  editarBanco() {}
  deletarBanco() {}

  buttonClicked(item: any) {
    this.buttonClick.emit(item);
  }
}
